import { IonIcon, IonSpinner } from '@ionic/react';
import React from 'react';

import { documentTextOutline } from 'ionicons/icons';

import { usePdfThumbnail } from '../../../hooks/Utils/usePdfThumbnail';
import './PdfThumbnail.scss';

type PdfThumbnailProps = {
  url: string;
  onClick?: () => void;
  className?: string;
  variant?: 'thumbnail' | 'fullview';
};

const PdfThumbnail: React.FC<PdfThumbnailProps> = ({
  url,
  onClick,
  className = '',
  variant = 'thumbnail',
}) => {
  const scale = variant === 'fullview' ? 1.5 : 0.5;
  const { thumbnailUrl, isLoading, error } = usePdfThumbnail(url, scale);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const baseClass =
    variant === 'fullview' ? 'pdf-preview-fullview' : 'pdf-preview-thumbnail';

  // Estado de carga
  if (isLoading) {
    return (
      <div
        className={`${baseClass} ${baseClass}--loading ${className}`}
        onClick={handleClick}
      >
        <IonSpinner color="medium" />
        <span className="pdf-preview-label">Cargando PDF...</span>
      </div>
    );
  }

  // Error o no se pudo generar thumbnail
  if (error || !thumbnailUrl) {
    return (
      <div
        className={`${baseClass} ${baseClass}--error ${className}`}
        onClick={handleClick}
      >
        <IonIcon icon={documentTextOutline} className="pdf-preview-icon" />
        <span className="pdf-preview-label">
          {variant === 'fullview' ? 'Toca para abrir PDF' : 'PDF'}
        </span>
      </div>
    );
  }

  // Thumbnail generado exitosamente
  return (
    <div className={`${baseClass} ${className}`} onClick={handleClick}>
      <img src={thumbnailUrl} alt="Vista previa PDF" className="pdf-preview-image" />
      <div className="pdf-preview-overlay">
        <span className="pdf-preview-badge">PDF</span>
      </div>
    </div>
  );
};

export default React.memo(PdfThumbnail);
